<template>
  <dashboard-section>
    <ul class="list-reset">
      <li
        v-for="(pot, index) in funding"
        :key="`${pot.id}_${index}`"
        class="w-full shadow"
      >
        <article class="flex shadow-lg">
          <div class="w-1/3 flex-no-shrink bg-secondary-500 p-6">
            <h1 class="uppercase text-sm text-grey-300">Wave {{ pot.id }}</h1>
          </div>
          <div class="flex-1 flex flex-wrap">
            <a
              class="flex-1 flex m-4 p-6 items-center justify-center no-underline text-xl text-grey-900 hover:shadow-lg transition-all tracking-normal"
              :href="route('funding.eoi.index', { funding: pot.id })"
            >
              Expression of interests
            </a>
            <a
              class="flex-1 flex m-4 p-6 items-center justify-center no-underline text-xl text-grey-900 hover:shadow-lg transition-all tracking-normal"
              :href="route('funding.applications.index', { funding: pot.id })"
            >
              Applications
            </a>
          </div>
        </article>
      </li>
    </ul>
  </dashboard-section>
</template>

<script>
export default {
  name: "AdminDashboardCompetitions",
  props: {
    funding: {
      type: Array,
      default: () => []
    }
  }
};
</script>
